<template>
    <div>
        <v-container justify-start pb-0>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">Players</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/players" v-bind:exact="exact">Players</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-btn flat small color="primary" class="mb-3 mt-3" to="/admin/players/new" right>New Player</v-btn>
        </v-container>
        <v-container grid-list-md justify-start pt-0>
            <v-layout>
                <v-flex xs12 lg9>
                    <v-card>
                        <v-card-title>
                            <v-flex xs12 sm6 md4 xl3>
                                <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-flex>
                        </v-card-title>
                        <v-data-table
                            v-bind:headers="headers"
                            v-bind:items="players"
                            v-bind:search="search"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <td>{{ props.item.last_name }}</td>
                                <td>{{ props.item.first_name }}</td>
                                <td>{{ props.item.email }}</td>
                                <td>{{ props.item.phone }}</td>
                                <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-on:click="issueEdit(props.item)"
                                >
                                    edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-on:click="issueDelete(props.item)"
                                >
                                    delete
                                </v-icon>
                                </td>
                            </template>
                            <template v-slot:no-results>
                                Your search for "{{ search }}" found no results.
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

export default {
    name: 'AdminPlayers',
    data() {
        return {
            exact: true,
            admin: true,
            search: '',
            headers: [
                {
                    text: 'Last Name',
                    align: 'left',
                    sortable: true,
                    value: 'last_name'
                },
                {
                    text: 'First Name',
                    align: 'left',
                    sortable: true,
                    value: 'first_name'
                },
                {
                    text: 'Email',
                    align: 'left',
                    value: 'email'
                },
                {
                    text: 'Phone',
                    align: 'left',
                    value: 'phone'
                }
            ]
        }
    },
    methods: {
        issueEdit(player) {
            this.$router.push({name: 'admin_players_edit', params: {id: player.id}})
        },
        issueDelete(player) {
            this.$store.dispatch('deletePlayer', {
                player: player
            })
        }
    },
    computed: {
        players() {
            return this.$store.getters.getPlayersSortedByLastName
        }
    }
}
</script>

<style scoped></style>
